
import {
  SELECT_TRANSCRIPTS,
  DESELECT_TRANSCRIPT,
  SET_TOTAL_COUNT,
  HIDE_SELECTED_TRANSCRIPT,
  SHOW_SELECTED_TRANSCRIPT,
  ON_REMOVED_TRANSCRIPTS,
} from './transcriptViewerActions'
import { FIRST_START, LOGIN_BY_PARAMETERS_FROM_URL } from '../../store/actions/appActions'
import { LOGIN } from '../login/loginActions'

export const initialState = {
  selectionFilter: [],
  selectedTranscriptForPreviev: undefined,
  lastClickTimeSelectAll: undefined,
  isHideSelectedTranscript: false,
  totalCount: 0,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FIRST_START:
      return { ...state }
    case SET_TOTAL_COUNT:
      return { ...state, totalCount: Number(payload) }

    /* selectedTranscripts */
    case SELECT_TRANSCRIPTS:
      return {
        ...state,
        selectionFilter: payload.selectionFilter,
        selectedTranscriptForPreviev: payload.selectedTranscriptForPreviev,
        lastClickTimeSelectAll: payload.lastClickTimeSelectAll,
        isHideSelectedTranscript: false,
      }
    case DESELECT_TRANSCRIPT:
    case ON_REMOVED_TRANSCRIPTS:
    case LOGIN:
    case LOGIN_BY_PARAMETERS_FROM_URL:
      return {
        ...state,
        selectionFilter: initialState.selectionFilter,
        selectedTranscriptForPreviev: initialState.selectedTranscriptForPreviev,
        lastClickTimeSelectAll: initialState.lastClickTimeSelectAll,
      }
    case HIDE_SELECTED_TRANSCRIPT:
      return { ...state, isHideSelectedTranscript: true }
    case SHOW_SELECTED_TRANSCRIPT:
      return { ...state, isHideSelectedTranscript: false }

    default:
      return state
  }
}
